import React, {FC} from "react";
import {ArrowRightIcon} from "@heroicons/react/solid";
import ButtonSecondary from "../../components/Button/ButtonSecondary";

export interface SectionTeam {
    className?: string;
    rightImg?: string;
}

const SectionTeam: FC<SectionTeam> = ({
                                          className = "",
                                      }) => {
    return (
        <div
            className={`text-center justify-center SectionTeam relative flex flex-col lg:flex-row items-center  ${className}`}
            data-id="SectionTeam"
        >
            <div className="text-center justify-center flex-shrink-0 mb-14 lg:mb-0 lg:mr-10 lg:w-2/5">
                <h2 className="font-semibold text-3xl sm:text-4xl mt-3">
                BUILDING IS BELIEVING
                </h2>
                <span className="justify-center block mt-8 text-neutral-500 dark:text-neutral-400">
                                We are a team of developers passionate about the decentralised technology ecosystem.

        </span>


                <div className="flex space-x-4 mt-1 justify-center py-10">
                    <ButtonSecondary href={"/about"}>Meet Our Team<ArrowRightIcon className="w-5 h-5 ml-2"/>
                    </ButtonSecondary>
                </div>
            </div>
        </div>
    );
};

export default SectionTeam;

